import "core-js/modules/es.number.constructor.js";
import UploadImage from "@/components/upload/image.vue";
export default {
  name: "role_id",
  props: {
    param: {
      type: Object,
      default: function _default() {}
    },
    value: {
      type: [Array, String, Number, Object],
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    UploadImage: UploadImage
  },
  data: function data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    inputValue: {
      handler: function handler(newVal) {
        this.$emit("input", newVal);
      }
    },
    deep: true,
    immediate: true
  }
};